/**
 * Akan (veya hazir) metni seslendirilecek parcalara boler.
 *
 * Sesli gorusme (`callSession.ts`) ve "sesli oku" dugmesi (`speech.ts`)
 * ortak kullaniyor: ikisinde de metin parca parca seslendiriliyor, bir parca
 * calarken sonraki hazirlaniyor.
 */

const BOUNDARY = /[.!?…]+["'”’)\]]*(?=\s)|\n+/g
const MIN_CHARS = 12
const MAX_CHARS = 220
/** Ilk parca bundan uzunsa ilk virgulden kesiliyor (bkz. `findCut`). */
const FIRST_MAX_CHARS = 70

function firstComma(text: string): number {
  const index = text.indexOf(', ', 20)
  return index > 0 && index <= FIRST_MAX_CHARS + 30 ? index + 1 : -1
}

/**
 * Akan metni seslendirilecek parcalara boler.
 *
 * Cumle sonu ancak ARKASINDAN bosluk gelince kesin: "3.5" veya akisin tam
 * noktada durmasi yanlis kesim uretmesin. Kod blogu kapanana kadar
 * bekleniyor (sunucu kod bloklarini zaten okumuyor; yarim blok ise okunur
 * metne karisirdi). Noktalamasiz uzun metin virgulden/bosluktan kesiliyor.
 */
export class SentenceSplitter {
  private buffer = ''
  private emitted = 0

  push(text: string): string[] {
    this.buffer += text
    const out: string[] = []
    for (;;) {
      const cut = findCut(maskCode(this.buffer), this.emitted === 0)
      if (cut < 0) break
      const chunk = this.buffer.slice(0, cut).trim()
      this.buffer = this.buffer.slice(cut)
      if (chunk) {
        out.push(chunk)
        this.emitted++
      }
    }
    return out
  }

  flush(): string[] {
    const rest = this.buffer.trim()
    this.buffer = ''
    return rest ? [rest] : []
  }
}

/**
 * Kod bloklarini kesilemez yapar: kapanmis bloklarin ici ve acik kalan
 * blogun tamami, uzunluk korunarak noktalamasiz bir dolguyla degistiriliyor.
 * Kesim konumlari boylece ozgun metinde de gecerli; acik bloktan ONCEKI
 * metin ise beklemeden okunabiliyor.
 */
function maskCode(text: string): string {
  const closed = text.replace(/```[\s\S]*?```/g, (block) => 'x'.repeat(block.length))
  const open = closed.indexOf('```')
  return open < 0 ? closed : closed.slice(0, open) + '\u0000'.repeat(closed.length - open)
}

function findCut(masked: string, first = false): number {
  let text = masked
  BOUNDARY.lastIndex = 0
  let match: RegExpExecArray | null
  while ((match = BOUNDARY.exec(text))) {
    const end = match.index + match[0].length
    if (end >= MIN_CHARS) {
      // Ilk parca UZUNSA virgulden kes: Chatterbox'ta ilk ses, parcanin
      // TAMAMI uretilince geliyor - kisa ilk parca = erken ilk ses.
      if (first && end > FIRST_MAX_CHARS) {
        const comma = firstComma(text)
        if (comma > 0 && comma < end) return comma
      }
      return end
    }
  }
  // Cumle henuz bitmedi ama ilk parca icin yeterince uzun: virgulden kes.
  if (first && text.length > FIRST_MAX_CHARS) {
    const comma = firstComma(text)
    if (comma > 0) return comma
  }
  const open = text.indexOf('\u0000')
  if (open >= 0) text = text.slice(0, open)
  if (text.length > MAX_CHARS) {
    const window = text.slice(0, MAX_CHARS)
    const comma = window.lastIndexOf(', ')
    if (comma > MIN_CHARS) return comma + 1
    const space = window.lastIndexOf(' ')
    return space > MIN_CHARS ? space : MAX_CHARS
  }
  return -1
}
